
const parts = {

    'P1010S': {
        //'description': () => 'Oil-Only Pillow 10" x 10"',
        'Plastic Waste Diversion (lbs.)': (n) => (n * 0.45),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (lbs. Unit)': (n) => (n * 10.4545),
        'Average CO2 Reduction (lbs. CO2/lbs. Unit)': (n) => (n * -3.53),
        'Plastic Waste Diversion (kg)': (n) => parseFloat(((n * 0.45) * 0.45359237)),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (kg. Unit)': (n) => parseFloat(((n * 10.4545) * 0.45359237)),
        'Average CO2 Reduction (kg. CO2/kg. Unit)': (n) => parseFloat(((n * -3.53) * 0.45359237)),
        'Approximate Plastic Bottles Diverted (bottles)': (n) => ((n * 0.45) / 0.04),
    },

    'P1212S': {
        //'description': () => 'Oil-Only Pillow 12" x 12"',
        'Plastic Waste Diversion (lbs.)': (n) => (n * 0.6),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (lbs. Unit)': (n) => (n * 11.536),
        'Average CO2 Reduction (lbs. CO2/lbs. Unit)': (n) => (n * -4.76),
        'Plastic Waste Diversion (kg)': (n) => parseFloat(((n * 0.6) * 0.45359237)),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (kg. Unit)': (n) => parseFloat(((n * 11.536) * 0.45359237)),
        'Average CO2 Reduction (kg. CO2/kg. Unit)': (n) => parseFloat(((n * -4.76) * 0.45359237)),
        'Approximate Plastic Bottles Diverted (bottles)': (n) => ((n * 0.6) / 0.04),
    },

    'P1616S': {
        //'description': () => 'Oil-Only Pillow 16" x 16"',
        'Plastic Waste Diversion (lbs.)': (n) => (n * 1.2),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (lbs. Unit)': (n) => (n * 15.862),
        'Average CO2 Reduction (lbs. CO2/lbs. Unit)': (n) => (n * -7.39),
        'Plastic Waste Diversion (kg)': (n) => parseFloat(((n * 1.2) * 0.45359237)),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (kg. Unit)': (n) => parseFloat(((n * 15.862) * 0.45359237)),
        'Average CO2 Reduction (kg. CO2/kg. Unit)': (n) => parseFloat(((n * -7.39) * 0.45359237)),
        'Approximate Plastic Bottles Diverted (bottles)': (n) => ((n * 1.2) / 0.04),
    },

    'S0312S': {
        //'description': () => 'Oil-Only Sock 3"x 12"',
        'Plastic Waste Diversion (lbs.)': (n) => (n * 0.25),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (lbs. Unit)': (n) => (n * 9.0125),
        'Average CO2 Reduction (lbs. CO2/lbs. Unit)': (n) => (n * -1.17),
        'Plastic Waste Diversion (kg)': (n) => parseFloat(((n * 0.25) * 0.45359237)),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (kg. Unit)': (n) => parseFloat(((n * 9.0125) * 0.45359237)),
        'Average CO2 Reduction (kg. CO2/kg. Unit)': (n) => parseFloat(((n * -1.17) * 0.45359237)),
        'Approximate Plastic Bottles Diverted (bottles)': (n) => ((n * 0.25) / 0.04),
    },

    'S0324S': {
        //'description': () => 'Oil-Only Sock 3" x 24"',
        'Plastic Waste Diversion (lbs.)': (n) => (n * 0.5),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (lbs. Unit)': (n) => (n * 10.815),
        'Average CO2 Reduction (lbs. CO2/lbs. Unit)': (n) => (n * -2.49),
        'Plastic Waste Diversion (kg)': (n) => parseFloat(((n * 0.5) * 0.45359237)),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (kg. Unit)': (n) => parseFloat(((n * 10.815) * 0.45359237)),
        'Average CO2 Reduction (kg. CO2/kg. Unit)': (n) => parseFloat(((n * -2.49) * 0.45359237)),
        'Approximate Plastic Bottles Diverted (bottles)': (n) => ((n * 0.5) / 0.04),
    },

    'S0348S': {
        //'description': () => 'Oil-Only Sock 3" x 48"',
        'Plastic Waste Diversion (lbs.)': (n) => (n * 1),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (lbs. Unit)': (n) => (n * 14.42),
        'Average CO2 Reduction (lbs. CO2/lbs. Unit)': (n) => (n * -4.98),
        'Plastic Waste Diversion (kg)': (n) => parseFloat(((n * 1) * 0.45359237)),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (kg. Unit)': (n) => parseFloat(((n * 14.42) * 0.45359237)),
        'Average CO2 Reduction (kg. CO2/kg. Unit)': (n) => parseFloat(((n * -4.98) * 0.45359237)),
        'Approximate Plastic Bottles Diverted (bottles)': (n) => ((n * 1) / 0.04),
    },

    'B0310S': {
        //'description': () => 'Oil-Only Boom 3" x 120"',
        'Plastic Waste Diversion (lbs.)': (n) => (n * 3),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (lbs. Unit)': (n) => (n * 61.285),
        'Average CO2 Reduction (lbs. CO2/lbs. Unit)': (n) => (n * -13.85),
        'Plastic Waste Diversion (kg)': (n) => parseFloat(((n * 3) * 0.45359237)),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (kg. Unit)': (n) => parseFloat(((n * 61.285) * 0.45359237)),
        'Average CO2 Reduction (kg. CO2/kg. Unit)': (n) => parseFloat(((n * -13.85) * 0.45359237)),
        'Approximate Plastic Bottles Diverted (bottles)': (n) => ((n * 3) / 0.04),
    },

    'B0510S': {
        //'description': () => 'Oil-Only Boom 3" x 120"',
        'Plastic Waste Diversion (lbs.)': (n) => (n * 5.3),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (lbs. Unit)': (n) => (n * 67.053),
        'Average CO2 Reduction (lbs. CO2/lbs. Unit)': (n) => (n * -24.76),
        'Plastic Waste Diversion (kg)': (n) => parseFloat(((n * 5.3) * 0.45359237)),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (kg. Unit)': (n) => parseFloat(((n * 67.053) * 0.45359237)),
        'Average CO2 Reduction (kg. CO2/kg. Unit)': (n) => parseFloat(((n * -24.76) * 0.45359237)),
        'Approximate Plastic Bottles Diverted (bottles)': (n) => ((n * 5.3) / 0.04),
    },

    'B0810S': {
        //'description': () => 'Oil-Only Boom 8" x 120"',
        'Plastic Waste Diversion (lbs.)': (n) => (n * 11.5),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (lbs. Unit)': (n) => (n * 106.3475),
        'Average CO2 Reduction (lbs. CO2/lbs. Unit)': (n) => (n * -47.77),
        'Plastic Waste Diversion (kg)': (n) => parseFloat(((n * 11.5) * 0.45359237)),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (kg. Unit)': (n) => parseFloat(((n * 106.3475) * 0.45359237)),
        'Average CO2 Reduction (kg. CO2/kg. Unit)': (n) => parseFloat(((n * -47.77) * 0.45359237)),
        'Approximate Plastic Bottles Diverted (bottles)': (n) => ((n * 11.5) / 0.04),
    },

    'M2015': {
        //'description': () => '  Oil-Only Mat 20" x 15"',
        'Plastic Waste Diversion (lbs.)': (n) => (n * 0.085),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (lbs. Unit)': (n) => (n * 1.6275),
        'Average CO2 Reduction (lbs. CO2/lbs. Unit)': (n) => (n * 0),
        'Plastic Waste Diversion (kg)': (n) => parseFloat(((n * 0.085) * 0.45359237)),
        'Plastic Waste Diversion Sorbent + Absorbed Oil (kg. Unit)': (n) => parseFloat(((n * 1.6275) * 0.45359237)),
        'Average CO2 Reduction (kg. CO2/kg. Unit)': (n) => parseFloat(((n * 0) * 0.45359237)),
        'Approximate Plastic Bottles Diverted (bottles)': (n) => ((n * 0.085) / 0.04),
    },

};


document.querySelectorAll('.gbc').forEach((container) => {


    const calc = () => {

        const calcRunningTotals = {
            'Plastic Waste Diversion (lbs.)': 0,
            'Plastic Waste Diversion Sorbent + Absorbed Oil (lbs. Unit)': 0,
            'Average CO2 Reduction (lbs. CO2/lbs. Unit)': 0,
            'Plastic Waste Diversion (kg)': 0,
            'Plastic Waste Diversion Sorbent + Absorbed Oil (kg. Unit)': 0,
            'Average CO2 Reduction (kg. CO2/kg. Unit)': 0,
            'Approximate Plastic Bottles Diverted (bottles)': 0,
        };

        const subForms = container.querySelectorAll('.gbc__form');

        subForms.forEach((subForm) => {
            const partno = subForm.querySelector('.gbc_part_no').value;
            const unitsInput = subForm.querySelector('.gbc__input');

            let value = +unitsInput.getAttribute('placeholder'); // default

            if (unitsInput.value.trim().length > 0) {
                value = +unitsInput.value;
            }

            if (isNaN(value)) {
                return;
            }

            const part = parts[partno];

            if (part) {

                for (const [k, v] of Object.entries(part)) {
                    calcRunningTotals[k] += v(value);
                }
            }

            const output = container.querySelector('#gb_output');
            let out = '';

                for (const [k, v] of Object.entries(calcRunningTotals)) {

                    const unitMatches = k.match(/\(([^)]+)\)/);
                    const units = unitMatches[1];
                    const name = k.replace(unitMatches[0], '');

                    out += `<div class="gbc__stat">
                        <h4>${
                            // round to 2 dec
                            (Math.round( (v + Number.EPSILON) * 10) / 10)
                            .toFixed(1)
                            .replace(/\.0+$/,'')
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }</h4>
                        <small>${units}</small>
                        <span>${name}</span>
                    </div>`;
                }

                output.innerHTML = out;
        });

    };

    const form = container.querySelector('#gb_form');

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        calc();
    });

    calc();

});